module.exports = __webpack_public_path__ + "img/Fourier.5c308701.jpg";